module.exports = __webpack_public_path__ + "img/lito.b16af759.jpg";